import {
  ISideBySideQuestionSchema,
  SideBySidePair,
  SideBySidePairs,
  SideBySideResponse,
  SideBySideSubmitResponse,
  SideBySideSubmitResponseFrame,
  IAnswerStyle
} from './types'

export const init = (questionSchema: ISideBySideQuestionSchema): SideBySidePairs => {
  const nodes: SideBySidePairs = []
  questionSchema.answers
    .filter(a => !a.hidden)
    .forEach((answer, i) => {
      questionSchema.answers
        .filter(a => !a.hidden)
        .forEach((xanswer, j) => {
          if (j >= i + 1) nodes.push([answer.id, xanswer.id])
        })
      nodes.sort(() => 0.5 - Math.random())
    })
  return nodes
}

export const choose = (
  choice: SideBySidePair,
  response: SideBySideResponse,
  pairs: SideBySidePairs,
  callback: (newPairs: SideBySidePairs, newResponse: SideBySideResponse) => void
) => {
  const currentChoice = { b: choice[0], w: choice[1] }
  response.push(currentChoice)
  pairs.splice(0, 1)
  response.forEach(existingPair => {
    if (existingPair.b == currentChoice.w && !response.some(r => r.b == currentChoice.b && r.w == existingPair.w)) {
      response.push({ b: currentChoice.b, w: existingPair.w })
      const id = pairs.findIndex(el => el[0] == currentChoice.b && el[1] == existingPair.w)
      if (id >= 0) pairs.splice(id, 1)
    }
    if (existingPair.w == currentChoice.b && !response.some(r => r.b == existingPair.b && r.w == currentChoice.w)) {
      response.push({ b: existingPair.b, w: currentChoice.w })
      const id = pairs.findIndex(el => el[0] == existingPair.b && el[1] == currentChoice.w)
      if (id >= 0) pairs.splice(id, 1)
    }
  })
  callback(pairs, response)
}

export const makeResponse = (
  questionSchema: ISideBySideQuestionSchema,
  response: SideBySideResponse
): SideBySideSubmitResponse => {
  const newAroAnswers = questionSchema.answers
    .filter(a => !a.hidden)
    .reduce((prev: SideBySideSubmitResponse, cur) => {
      prev.push({ id: cur.id })
      return prev
    }, [])
  if (questionSchema.answers.filter(a => !a.hidden).length) {
    let counter = 0
    let changed = false
    do {
      changed = false
      response.forEach(function (el) {
        const bIndex = newAroAnswers.findIndex((answer: SideBySideSubmitResponseFrame) => answer.id == el.b)
        const wIndex = newAroAnswers.findIndex((answer: SideBySideSubmitResponseFrame) => answer.id == el.w)
        if (bIndex > wIndex) {
          newAroAnswers[bIndex] = { id: el.w }
          newAroAnswers[wIndex] = { id: el.b }
          changed = true
        }
      })
      counter += 1
    } while (counter < 1000 && changed)
  }

  return newAroAnswers
}

const resizeText = (text: string, width: number): IAnswerStyle => {
  const h = document.querySelector('body')
  const d = document.createElement('div')
  const s = document.createElement('span')
  let it = Math.min(width, 100)
  d.style.display = 'block'
  d.style.width = width - 5 + 'px'
  d.style.height = width - 5 + 'px'
  d.style.fontSize = it + 'px'
  d.style.whiteSpace = 'normal'
  d.style.lineHeight = it + 'px'
  // eslint-disable-next-line unicorn/prefer-dom-node-append
  h.appendChild(d)
  s.style.display = 'inline'
  s.style.fontSize = it + 'px'
  s.style.fontFamily = 'Ubuntu, Calibri, Segoe, Helvetica, Arial'
  s.style.lineHeight = it + 'px'
  s.innerHTML = text
  // eslint-disable-next-line unicorn/prefer-dom-node-append
  d.appendChild(s)

  let sw = s.offsetWidth
  let sh = s.offsetHeight

  while ((sw > width - 25 || sh > width - 25) && it > 15) {
    it -= Math.ceil(sw / (width - 5))
    d.style.fontSize = it + 'px'
    d.style.lineHeight = it + 'px'
    s.style.fontSize = it + 'px'
    s.style.lineHeight = it + 'px'
    sw = s.offsetWidth
    sh = s.offsetHeight
  }

  // eslint-disable-next-line unicorn/prefer-dom-node-remove
  h.removeChild(d)
  return {
    fontSize: it,
    lineHeight: it
  }
}

export const getStyle = (schema: ISideBySideQuestionSchema, width: number): IAnswerStyle =>
  schema.answers.reduce((res, item) => {
    const fontStyleItem = resizeText(item.text, width / 2 - 50)
    return !res.fontSize || fontStyleItem.fontSize < res.fontSize ? fontStyleItem : res
  }, {} as IAnswerStyle)
